/**
 * Estado "esta area entra na fase N".
 *
 * Wireframes §13 exige que todo estado vazio seja especificado e que NENHUM
 * mostre um zero enganoso. Uma area sem dado precisa dizer tres coisas:
 * o que ela vai mostrar, por que ainda nao mostra, e o que falta.
 *
 * A alternativa comum — tela em branco ou grafico zerado — faz o operador achar
 * que o sistema esta quebrado, ou pior, que o numero real e zero.
 */
export function PhasePending({
  area,
  phase,
  reason,
  willShow,
}: {
  area: string;
  /**
   * Fase em que a area passa a ter dado, quando ja foi decidida.
   *
   * OPCIONAL desde 17/09: o layout entregue pelo cliente criou areas
   * ("Ativos e Conhecimento", "Usuarios e Acesso", "Ajuda e Documentacao") que
   * ainda nao tiveram fase atribuida. Escrever um numero para preencher o campo
   * anunciaria na tela um compromisso que ninguem assumiu, e o texto abaixo
   * existe justamente para nao mentir sobre o que falta.
   */
  phase?: number;
  reason: string;
  willShow?: readonly string[];
}) {
  return (
    <section className="max-w-2xl" aria-labelledby="titulo-fase-pendente">
      <h1 id="titulo-fase-pendente" className="text-xl font-semibold">
        {area}
      </h1>

      <p className="mt-3 rounded-card border border-line-strong bg-surface px-3 py-2 text-sm">
        <span className="font-semibold">Sem dado nesta fase.</span>{' '}
        {phase === undefined ? (
          <>
            Esta área foi desenhada no layout do Console e ainda{' '}
            <span className="font-semibold">não tem fase definida</span>.
          </>
        ) : (
          <>
            Esta área passa a ter conteúdo na <span className="font-semibold">fase {phase}</span>.
          </>
        )}
      </p>

      <h2 className="mt-4 text-sm font-semibold">Por que ainda não há dado</h2>
      <p className="mt-1 text-sm text-ink-muted">{reason}</p>

      {willShow && willShow.length > 0 && (
        <>
          <h2 className="mt-4 text-sm font-semibold">O que vai aparecer aqui</h2>
          <ul className="mt-1 list-inside list-disc text-sm text-ink-muted">
            {willShow.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </>
      )}

      <p className="mt-4 text-xs text-ink-faint">
        Nenhum número é exibido nesta tela de propósito: ausência de dado não é zero.
      </p>
    </section>
  );
}
